<template>
    <header
        class="base-hero"
        :class="{
            'base-hero--masked-background': maskedBackground
        }"
    >
        <hgroup
            v-if="!!props.title || !!$slots.title || !!$slots.titleElement"
            class="base-hero__title"
        >
            <slot name="titleElement">
                <h1 v-if="props.title || !!$slots.title">
                    <slot name="title">{{ props.title }}</slot>
                </h1>
            </slot>
        </hgroup>

        <div
            v-if="!!props.description || !!$slots.description"
            class="base-hero__description"
        >
            <slot name="description">
                <!-- eslint-disable -->
            <div
                v-if="props.description"
                v-html="props.description"
            />
            <!-- eslint-enable -->
            </slot>
        </div>
        <slot name="cta">
            <CraftLink v-if="cta" v-slot="{ to, label}" :link="cta">
                <BaseButton
                    :element="defineNuxtLink({})"
                    :to
                    class="base-hero__cta"
                    :label
                    icon="marker:arrow_1_right"
                />
            </CraftLink>
        </slot>
        <div v-if="footerText" class="base-hero__footer-text" v-html="footerText" />
        <slot />
    </header>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: null
    },
    description: {
        type: String,
        default: null
    },
    cta: {
        type: Object,
        default: null
    },
    footerText: {
        type: String,
        default: null
    },
    maskedBackground: {
        type: Boolean,
        default: false
    }
});
</script>

<style lang="less" src="./BaseHero.less" />
